import { useRef, useState, useCallback } from 'react'
import makeStyles from '@mui/styles/makeStyles'
import debounce from 'lodash/debounce'
import { DatasetStatus, SubmissionStatusIndicator } from '@components'
import { Submission } from '@global/types'
import { SubmissionStatusPopover } from './submissionStatusPopover'

const useStyles = makeStyles(() => ({
  container: {
    display: 'inline-grid',
    position: 'relative',
  },
}))

interface Props {
  submission: Submission
  submissionSummary: any
  approvalFlowEnabled: boolean
}

export const SubmissionStatusCell = ({
  submission,
  submissionSummary,
  approvalFlowEnabled,
}: Props) => {
  const classes = useStyles()
  const anchorRef = useRef(null)
  const [showPopover, setShowPopover] = useState(false)

  const onClick = useCallback(e => {
    e.stopPropagation()
  }, [])

  const onMouseLeave = useCallback(
    debounce(() => {
      setShowPopover(false)
    }, 150),
    [],
  )

  const onMouseEnter = useCallback(() => {
    onMouseLeave.cancel()
    setShowPopover(true)
  }, [onMouseLeave])

  return (
    <>
      <div
        ref={anchorRef}
        className={classes.container}
        onMouseEnter={onMouseEnter}
        onMouseLeave={onMouseLeave}
        onClick={onClick}
        aria-hidden="true"
      >
        <SubmissionStatusIndicator status={submission.status as DatasetStatus} />
      </div>
      <SubmissionStatusPopover
        anchorEl={anchorRef.current}
        submission={submission}
        submissionSummary={submissionSummary}
        open={showPopover}
        approvalFlowEnabled={approvalFlowEnabled}
        onMouseEnter={onMouseEnter}
        onMouseLeave={onMouseLeave}
        onClick={onClick}
      />
    </>
  )
}
